import MBuckyCarousel from '../carousels/MBuckyCarousel';
import React, { ReactNode, useCallback, useState } from 'react';
import imageLast from '../../../../assets/images/games/m-game/ws2.webp';

export default function MBuckyCipher() {
    const [selectedSlide, setSelectedSlide] = useState(0);
    const [questions, setQuestions] = useState([
        { q: 'Z čoho je vyrobený štít Kapitána Ameriky?', id: 1 },
        { q: 'Flerkeni sú nebezpečná rasa, ktorá sa podobá na čo?', id: 2 },
        { q: 'Ktorý literárny detektív bol hraný 2 Avengermi?', id: 3 },
        { q: 'Ktorú postavu hrá režisér Taika Waititi?', id: 4 },
        { q: 'Ktorý herec hral v Marvel filme fiktívneho Lokiho v hre o jeho živote?', id: 5 },
        { q: 'Ako sa volal posledný Black Panther?', id: 6 },
        { q: 'Aká rasa je Loki?', id: 7 },
        { q: 'Ako sa volá najlepší priateľ Petera Parkera? (MCU)', id: 8 },
        { q: 'Ako sa volal sluha Tonyho Starka predtým než sa zmenil na Visiona?', id: 9 },
        { q: 'Kto ako jediný z Avengerov dokáže zdvihnúť Thorovo kladivo? (okrem Thora)', id: 10 },
        { q: 'Aké je skutočné meno Hawkeya?', id: 11 },
        { q: 'Ktoré oko Nicka Furyho má pásku?', id: 12 },
        { url: imageLast, id: 100 },
    ]);
    const [answers, setAnswers] = useState([
        { name: 'Hady', id: 1000 },
        { name: 'Vibranium', id: 1 },
        { name: 'Jarvis', id: 9 },
        { name: 'Jupiter Jones', id: 1000 },
        { name: 'Ned Stark', id: 1000 },
        { name: 'Zorg', id: 1000 },
        { name: 'Marvin', id: 1000 },
        { name: 'Trpaslík', id: 1000 },
        { name: 'Ježkovia', id: 1000 },
        { name: 'ľavé', id: 12 },
        { name: 'Frost Giant', id: 7 },
        { name: 'Sherlock Holmes', id: 3 },
        { name: 'Tom Hiddleston', id: 1000 },
        { name: 'Borg', id: 1000 },
        { name: 'Adamantium', id: 1000 },
        { name: 'Kapitán Amerika', id: 10 },
        { name: 'Wanda', id: 1000 },
        { name: 'Vision', id: 1000 },
        { name: "T'Chaka", id: 1000 },
        { name: 'Matt Damon', id: 5 },
        { name: 'Tom Cruise', id: 1000 },
        { name: 'pravé', id: 1000 },
        { name: 'Mačky', id: 2 },
        { name: 'Ted Lasso', id: 1000 },
        { name: 'Titanium', id: 1000 },
        { name: "T'Challa", id: 6 },
        { name: 'Človek', id: 1000 },
        { name: 'Ned Leeds', id: 8 },
        { name: "T'Laka", id: 1000 },
        { name: 'Hercule Poirot', id: 1000 },
        { name: 'Clint Barton', id: 11 },
        { name: 'Korg', id: 4 },
    ]);

    const onCompleteSlide = useCallback((idx: number, _item: ReactNode) => {
        setSelectedSlide(idx);
    }, []);

    const removeOnIndex = (n: number) => {
        if (n === questions[selectedSlide].id) {
            const filteredQuestions = questions.filter((v) => v.id !== n);
            const filteredAnswers = answers.filter((v) => v.id !== n);
            setQuestions(filteredQuestions);
            setAnswers(filteredAnswers);
        }
    };
    return (
        <React.Fragment>
            <div className="m-bucky">
                <MBuckyCarousel onCompleteSlide={onCompleteSlide} images={questions} />
                {answers && questions && questions.length > 1 && answers.length > 0 && (
                    <div className="m-bucky-names-wrapper">
                        {answers?.map((f, i) => {
                            return (
                                <div className="m-bucky-name" key={i} onClick={() => removeOnIndex(f.id)}>
                                    {f.name}
                                </div>
                            );
                        })}
                    </div>
                )}
                {!questions ||
                    (questions.length === 1 && (
                        <div className="m-bucky-solved">
                            Ruka sa našla, Tony mu ju len schoval do krabice! Bucky teraz môže ísť s nami a konflikt je
                            zažehnaný.
                        </div>
                    ))}
            </div>
        </React.Fragment>
    );
}
